import http from 'utils/http';

import API_DE from '../index';

export async function requestDealerLoanAdditionalDocumentAttachmentsDownload(documentAttachmentId: number) {
  await http.download(API_DE.LOAN_ADDITIONAL_DOCUMENT_ATTACHMENT.DOWNLOAD_ATTACHMENT(documentAttachmentId));
}
